var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.125a4.875 4.875 0 1 1 0 9.75 4.875 4.875 0 0 1 0-9.75M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12M9.648 5.9a.562.562 0 0 0-.795-.795l-2.6 2.602L5.15 6.604a.562.562 0 0 0-.795.795l1.5 1.5c.22.22.577.22.795 0z"
  })));
};
export default SvgCheckCircle;